import { render } from "./RequestFormMulti.vue?vue&type=template&id=2b53ce3e"
import script from "./RequestFormMulti.vue?vue&type=script&lang=js"
export * from "./RequestFormMulti.vue?vue&type=script&lang=js"

import "./RequestFormMulti.vue?vue&type=style&index=0&id=2b53ce3e&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__